import { StarlingText } from '@ad/ad_utils_react/src/components/business/TTCX/AddOn/types';
import { TFunction } from 'i18next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { GENERAL_SUBSCRIPTION_TERMS } from './StarlingKeys';

function SubscriptionGeneralTerms() {
  const [t] = useTranslation();

  function convertT(
    tFunc: TFunction<'translation', undefined>,
    content: StarlingText | undefined,
    isStyle = false
  ) {
    return isStyle ? (
      <Trans
        t={tFunc}
        i18nKey={content?.starlingKey}
        defaults={content?.fallbackText}
        components={{
          br: <br />,
          b: <b />
        }}
      />
    ) : (
      tFunc(content?.starlingKey || '', content?.fallbackText)
    );
  }

  return (
    <div className="general-terms">
      <h4>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.title)}</h4>
      <div>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.addOnDescription, true)}</div>
      <div>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.subscriptionDescription, true)}</div>
      <div>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.termsDisclaimer)}</div>
      <ol>
        <li>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.term1, true)}</li>
        <li>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.term2, true)}</li>
        <li>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.term3, true)}</li>
        <li>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.term4, true)}</li>
        <li>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.term5, true)}</li>
        <li>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.term6, true)}</li>
        <li>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.term7, true)}</li>
        <li>{convertT(t, GENERAL_SUBSCRIPTION_TERMS.term8, true)}</li>
      </ol>
    </div>
  );
}

export default SubscriptionGeneralTerms;
